import Vue from 'vue';
import Vuex from 'vuex';
import Postman from '@/services/postman';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiRoutes: null,
    currentRoute: null,
    rawData: null,
  },
  mutations: {
    setApiRoutes(state, routes) {
      // eslint-disable-next-line
      state.apiRoutes = routes;
    },
    setCurrentRoute(state, route) {
      // eslint-disable-next-line
      state.currentRoute = route;
    },
    setRawData(state, rawData) {
      // eslint-disable-next-line
      state.rawData = rawData;
    },
  },
  actions: {
    getCollection({ commit }) {
      return Postman.getAll()
        .then((response) => {
          if (response.data.collection !== undefined) {
            commit('setRawData', response.data);
            commit('setApiRoutes', response.data.collection.item);
            return { success: { name: 'getCollection', message: 'Successfully retrieved collection.' } };
          }
          return response.data.error;
        })
        .catch((error) => {
          console.error(error);
          return error;
        })
        .finally(() => {
          //
        });
    },
  },
  modules: {
  },
});
